/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { extendObservable } from 'mobx';
import { PatternStore } from 'src/luis/core/stores/patternStore';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';
import { SubtractStore } from 'src/luis/types/SubtractStore';

export type PatternStoreHouse = ResourceStoreHouse<PatternStore>;

/**
 * A factory function for creating an pattern store house,
 * which houses an array of pattern stores.
 */
export const createPatternStoreHouse = (): PatternStoreHouse => {
    const resourcesStoreHouse = createResourceStoreHouse<PatternStore>();

    const patternStoreHouse: SubtractStore<PatternStoreHouse, ResourceStoreHouse<PatternStore>> = {};

    return extendObservable(resourcesStoreHouse, patternStoreHouse, {}, { deep: false });
};
